import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconUpSolidComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-UpSolid${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path fillRule="evenodd" clipRule="evenodd" d="M11 5a6 6 0 00-6 6v19.427l7.11-6.866a2 2 0 012.605-.15l7.002 5.355 7.186-8.337-2.905-2.444a1 1 0 01.465-1.75l9.875-1.791a1 1 0 011.171 1.106L36.382 24.7a1 1 0 01-1.636.643l-2.782-2.34-8.45 9.802a2 2 0 01-2.729.283l-7.133-5.455L5 35.987V37a6 6 0 006 6h26a6 6 0 006-6V11a6 6 0 00-6-6H11z" fill={useCurrentColor ? 'currentColor' : '#34CFCC'}/></svg>;
}

const IconUpSolid = React.forwardRef(IconUpSolidComponent);
export default IconUpSolid;
